<template>
  <div>
    <proofArchiveList />
    <modalManageTags />
    <modalManageTagFilters />
    <renameItem />
    <v-tour
      name="proof-list"
      :steps="steps"
      :callbacks="tourCallbacks"
    ></v-tour>
  </div>
</template>

<script>
import proofArchiveList from "../components/proof-archive/proof-archive-list.vue";
import modalManageTags from "../components/modals/modal-managetags.vue";
import modalManageTagFilters from "../components/modals/modal-managetagsfilters.vue";
import renameItem from "../components/modals/modal-renameItem";

export default {
  components: {
    proofArchiveList,
    modalManageTags,
    modalManageTagFilters,
    renameItem,
  },
  data() {
    return {
      user: this.$A.Auth,
      steps: [
        {
          target: "#proofs_item",
          content: `Every proof created on your account lives here. Those icons show what file types are included in the proof. They are also color coded. Green means “Approved”, for example.`,
          params: { enableScrolling: false, placement: "top" },
        },
        {
          target: "#proofs_sort",
          content: "Use the filter sidebar to narrow proofs by status, owner, team, workflow, tags, and custom fields. Changes apply instantly.",
          params: { placement: "right" },
        },
        {
          target: "#proofs_tags",
          content: "Tags let you categorize proofs however you'd like. Pick one or more here to filter the archive.",
          params: { placement: "top" },
        },
      ],
      tourCallbacks: {
        onStop: function () {
          window.$A.SaveCompletionOfProductTours("proof-list");
        },
      },
    };
  },
};
</script>
